import api from "./api";

export async function getWallet(outletUid) {

    try {

        const response = await api.get(

            "/api/v1/nextgo/wallet",

            {

                params: {

                    outletUid,

                },

            }

        );

        return response.data;

    } catch (error) {

        console.error(

            "Failed to fetch wallet:",

            error

        );

        throw error;

    }

}

export async function getWalletDetails(outletUid) {

    const response =
        await api.get(

            "/api/v1/nextgo/wallet-details",

            {

                params: {

                    outletUid,

                },

            }

        );

    return response.data;

}